import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import View from 'ol/View.js';
import WMTS from 'ol/source/WMTS.js';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';
import { get as getProjection } from 'ol/proj.js';
import { getTopLeft, getWidth } from 'ol/extent.js';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4.js';

import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style } from 'ol/style.js';
import { OverviewMap, ScaleLine, defaults as defaultControls } from 'ol/control.js';
import TileWMS from 'ol/source/TileWMS.js';

const mapVersion = "1.3.5 (3.4.2025)";

const projection = getProjection('EPSG:3857');
const projectionExtent = projection.getExtent();

// Transparent Proj4js support:
proj4.defs("EPSG:5514", "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +units=m +no_defs");

register(proj4);

const JTSKprojection = getProjection('EPSG:5514');
JTSKprojection.extend = [-907841.0560214706, -1230916.868999999, -416691.670278527, -932111.7296999972];

var mapCenter = [-725744.38828, -1081015.72104];
var mapZoom = 11;
var startChoosen = false, endChoosen = false, middleChoosen = false;



if (typeof getInitMapZoom === 'function') {
    mapZoom = getInitMapZoom();
    console.log("getInitMapZoom prebral hodnotu " + mapZoom);
}
else {
    console.log("neni funkce getInitMapZoom pro prednastaveny zoom");
}

if (typeof getInitMapCoords === 'function') {
    mapCenter = getInitMapCoords();
    console.log("getInitMapCoords prebral hodnotu " + mapCenter);
}
else {
    console.warn("Warning: neni fuknce getInitMapCoords pro prednastaveny stred");
}


const size = getWidth(projectionExtent) / 256;
const resolutions = new Array(19);
const matrixIds = new Array(19);
for (let z = 0; z < 19; ++z) {
    // generate resolutions and matrixIds arrays for this WMTS
    resolutions[z] = size / Math.pow(2, z);
    matrixIds[z] = z;
}

// definice bodu
const image = new CircleStyle({
    radius: 5,
    fill: null,
    stroke: new Stroke({ color: 'red', width: 1 }),
});


// Definice Obarveni linii a objektu
const stylesTrip = {
    'Point': new Style({
        image: image,
    }),
    'LineString': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 3,
        }),
    }),
    'MultiLineString': new Style({
        stroke: new Stroke({
            color: 'green',
            width: 1,
        }),
    }),
    'MultiPoint': new Style({
        image: image,
    }),
    'MultiPolygon': new Style({
        stroke: new Stroke({
            color: 'yellow',
            width: 1,
        }),
        fill: new Fill({
            color: 'rgba(255, 255, 0, 0.1)',
        }),
    }),
    'Polygon': new Style({
        stroke: new Stroke({
            color: 'red',
            lineDash: [4],
            width: 3,
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)',
        }),
    }),
    'GeometryCollection': new Style({
        stroke: new Stroke({
            color: 'magenta',
            width: 2,
        }),
        fill: new Fill({
            color: 'magenta',
        }),
        image: new CircleStyle({
            radius: 10,
            fill: null,
            stroke: new Stroke({
                color: 'magenta',
            }),
        }),
    }),
    'Circle': new Style({
        stroke: new Stroke({
            color: 'red',
            width: 2,
        }),
        fill: new Fill({
            color: 'rgba(255,0,0,0.2)',
        }),
    }),
};

// Obarveni linii a objektu
const styleTripFunction = function (feature) {
    return stylesTrip[feature.getGeometry().getType()];
};


// WMTS - Ortofoto �R - m���tkov� �ada Google Maps
const ortoLayer = new TileLayer({
    source: new WMTS({
        url: 'https://ags.cuzk.cz/arcgis1/rest/services/ORTOFOTO_WM/MapServer/WMTS',
        matrixSet: 'GoogleMapsCompatible',
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid({
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
    }),
});

// WMTS - Z�kladn� topografick� mapy �R - m���tkov� �ada Google Maps
const topoLayer = new TileLayer({
    source: new WMTS({
        opacity: 0.5,
        //attributions:
        //    'Tiles � <a href="https://mrdata.usgs.gov/geology/state/"' +
        //    ' target="_blank">USGS</a>',
        url: 'https://ags.cuzk.cz/arcgis1/rest/services/ZTM_WM/MapServer/WMTS',
        layer: 'DEF_BUDOVY',
        matrixSet: 'GoogleMapsCompatible',
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid({
            origin: getTopLeft(projectionExtent),
            resolutions: resolutions,
            matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
    }),
});

// OSM
const osmLayer = new TileLayer({
    source: new OSM(),
});

// PlavebniUrad
const plavebniUradLayer = new TileLayer({
    extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
    source: new TileWMS({
        url: 'https://geoportal.plavebniurad.cz/arcgis/services/VodniCestyCR_WMS_JTSK/MapServer/WMSServer',
        params: { 'LAYERS': '1,6,13,14,22,28,30,34', 'TILED': true },
        serverType: 'geoserver',
        transition: 0,
        opacity: 1,
    }),
    name: 'plavebniurad'
});



ortoLayer.setVisible(false);
topoLayer.setVisible(false);

const pointLayers = [];

const PoisFunction = function (tripPoisUrl, name) {
    return new VectorLayer({
        source: new VectorSource({
            url: tripPoisUrl,
            format: new GeoJSON(),
            projection: JTSKprojection,
        }),
        name: name,
        style: PoiStyleFunction,
    });
}


const PoiStyleFunction = function (feature) {
    var actualZoom = map.getView().getZoom();
    var iconUrl = feature.get('iconUrl');
    if (actualZoom < 12.5 && actualZoom > 11.5) iconUrl = iconUrl.replace("c.gif", "b.gif").replace("c.png", "b.png");
    if (actualZoom <= 11.5) iconUrl = iconUrl.replace("c.gif", "a.gif").replace("c.png", "a.png");
    var defaultStyle = new Style({
        image: iconUrl ? new Icon({
            scale: actualZoom * 10 / 130,
            src: iconUrl
        }) : undefined
    });
    return [defaultStyle];
}

const overviewMapControl = new OverviewMap({
    className: 'ol-overviewmap ol-custom-overviewmap',
    layers: [
        new TileLayer({
            source: new OSM(),
        }),
    ],
    extent: [-895948.43, -1227766.9872, -454324.39, -953014.631],
    collapsed: false,
});


var layers = [
    ortoLayer,
    topoLayer,
    osmLayer
];

var idTrasy = null;
var showRecomendedTrip = false;
var showPlannedTrip = false;


//
if (typeof showCyclingRouteLayer === 'function') {

    var CyclingRoutePoisUrl;
    console.log("showCyclingRouteLayer existuje, zobrazuji linii cyklisticke trasy");
   
    if (typeof getCyclingRouteId === 'function') {
        console.log("getCyclingRouteId prebral CyclingRouteId:" + getCyclingRouteId());

        CyclingRoutePoisUrl = getCyclingRoutePoisSourceUrl();
        console.log("CyclingRoutePoisUrl set to:", CyclingRoutePoisUrl);

        const CyclingRouteLinie = new VectorLayer({
            style: styleTripFunction,
            source: new VectorSource({
                url: '//tourist.posazavi.com/Mapy/GeoJson/CyclingRoute/Linie.ashx?Id=' + getCyclingRouteId(),
                format: new GeoJSON()
            }),
            name: 'CyclingRouteLinie'
        });

        CyclingRouteLinie.getSource().on('featuresloadstart', function () {
            console.log("CyclingRouteLinie features load start");
        });

        CyclingRouteLinie.getSource().on('featuresloaderror', function (e) {
            console.error("CyclingRouteLinie features load error", e);
        });

        CyclingRouteLinie.getSource().on('featuresloadend', function (e) {
            console.log("CyclingRouteLinie features load end", e);
            var features = CyclingRouteLinie.getSource().getFeatures();
            features.forEach(function (feature) {
                map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] }/*, { duration: 1000 }*/);
            });
        });


        const CyclingRoutePois = new VectorLayer({
            source: new VectorSource({
                url: getCyclingRoutePoisSourceUrl(),
                format: new GeoJSON(),
                projection: JTSKprojection,
            }),
            name: 'CyclingRoutePois',
            style: PoiStyleFunction,
        });

        CyclingRoutePois.getSource().on('featuresloadstart', function () {
            console.log("CyclingRoutePois features load start");
        });

        CyclingRoutePois.getSource().on('featuresloaderror', function (e) {
            console.error("CyclingRoutePois features load error", e);
        });

        CyclingRoutePois.getSource().on('featuresloadend', function (e) {
            console.log("CyclingRoutePois features load end", e);
        });

        if (typeof getTripFilterSelected === 'function') {
            var url = getCyclingRoutePoisSourceUrl() + "&Filter=" + getTripFilterSelected();
            CyclingRoutePois.getSource().setUrl(url);
            CyclingRoutePois.getSource().refresh();
        }
        else {
            console.warn("Mapy - neexistuje funkce getTripFilterSelected");
        }

        layers.push(CyclingRouteLinie);
        layers.push(CyclingRoutePois);


        /* pois category selection change */
        if (typeof tripFilterEventListener === 'function') {
            console.log("Mapy - mam funkci tripFilterEventListener, zapojim filtrovani");
            tripFilterEventListener(filterCyclingRouteClick);
        }
        else {
            console.warn("Mapy - neexistuje funkce tripFilterEventListener, nepujde filtrovat");
        }

        function filterCyclingRouteClick() {
            console.log("Mapy.filterCyclingRouteClick - CLICKED filter for pois category");
            if (typeof getTripFilterSelected === 'function') {
                CyclingRoutePois.getSource().setUrl(CyclingRoutePoisUrl + "&Filter=" + getTripFilterSelected());
                CyclingRoutePois.getSource().refresh();
            }
            else {
                console.error("Mapy - neexistuje funkce getTripFilterSelected");
            }
4        }

    }
    else {
        console.error("neni funkce getCyclingRouteId naumim nacist linii cyklisticke trasy");
    }
}
else {
    console.log("neni funkce showCyclingRouteLayer nevykresluji vrstvu linii cyklisticke trasy");
}


if (typeof showRecomendedTripLayer === 'function') {

    var RecomendedTripPoisUrl;
    console.log("showRecomendedTripLayer existuje, zobrazuji linii doporuceneho vyletu");
    // Doporuceny vylet
    if (typeof getTripId === 'function') {
        console.log("getTripId prebral TripId:" + getTripId());

        RecomendedTripPoisUrl = getRecomendedTripPoisSourceUrl();
        console.log("RecomendedTripPoisUrl set to:", RecomendedTripPoisUrl);

        const RecomendedTripLinie = new VectorLayer({
            style: styleTripFunction,
            source: new VectorSource({
                url: '//tourist.posazavi.com/Mapy/GeoJson/Trip.ashx?Id=' + getTripId(),
                format: new GeoJSON()
            }),
            name: 'RecomendedTripLinie'
        });

        RecomendedTripLinie.getSource().on('featuresloadstart', function () {
            console.log("RecomendedTripLinie features load start");
        });

        RecomendedTripLinie.getSource().on('featuresloaderror', function (e) {
            console.error("RecomendedTripLinie features load error", e);
        });

        RecomendedTripLinie.getSource().on('featuresloadend', function (e) {
            console.log("RecomendedTripLinie features load end", e);
            var features = RecomendedTripLinie.getSource().getFeatures();
            features.forEach(function (feature) {
                map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] }/*, { duration: 1000 }*/);
            });
        });


        const RecomendedTripPois = new VectorLayer({
            source: new VectorSource({
                url: getRecomendedTripPoisSourceUrl(),
                format: new GeoJSON(),
                projection: JTSKprojection,
            }),
            name: 'RecomendedTripPois',
            style: PoiStyleFunction,
        });

        RecomendedTripPois.getSource().on('featuresloadstart', function () {
            console.log("RecomendedTripPois features load start");
        });

        RecomendedTripPois.getSource().on('featuresloaderror', function (e) {
            console.error("RecomendedTripPois features load error", e);
        });

        RecomendedTripPois.getSource().on('featuresloadend', function (e) {
            console.log("RecomendedTripPois features load end", e);
        });

        if (typeof getTripFilterSelected === 'function') {
            var url = RecomendedTripPoisUrl + "&Filter=" + getTripFilterSelected();
            RecomendedTripPois.getSource().setUrl(url);
            RecomendedTripPois.getSource().refresh();
        }
        else {
            console.warn("neexistuje funkce getTripFilterSelected");
        }

        layers.push(RecomendedTripLinie);
        layers.push(RecomendedTripPois);


        /* pois category selection change */
        if (typeof tripFilterEventListener === 'function') {
            console.log("mam funkci tripFilterEventListener, zapojim filtrovani");
            tripFilterEventListener(filterRecomendedClick);
        }
        else {
            console.warn("neexistuje funkce tripFilterEventListener, nepujde filtrovat");
        }

        function filterRecomendedClick() {
            console.log("Mapy.filterRecomendedClick - CLICKED filter for pois category");
            if (typeof getTripFilterSelected === 'function') {
                RecomendedTripPois.getSource().setUrl(RecomendedTripPoisUrl + "&Filter=" + getTripFilterSelected());
                RecomendedTripPois.getSource().refresh();
            }
            else {
                console.error("Mapy - neexistuje funkce getTripFilterSelected");
            }

        }

    }
    else {
        console.error("neni funkce getTripId naumim nacist linii doporuceneho vyletu");
    }
}
else {
    console.log("neni funkce showRecomendedTripLayer nevykresluji vrstvu linii doporuceneho vyletu");
}




if (typeof showPlannedTripLayer === 'function') {
    console.log("showPlannedTripLayer existuje, lze hledat");

    var PlannedTripPoisUrl = "";
    var BnHelpXml = "", BnHelpGml = "";
    function getBnHelpGml() { return BnHelpGml; }
    function getBnHelpXml() { return BnHelpXml; }

    function getPlannedTripPoisSourceUrl() {
        return '//tourist.posazavi.com/Mapy/GeoJson/TripPoisPlanning.ashx?xml=' + getBnHelpXml();
    }

    const PlannedTripPois = new VectorLayer({
        source: new VectorSource({
            url: getPlannedTripPoisSourceUrl(),
            format: new GeoJSON(),
            projection: JTSKprojection,
        }),
        name: 'PlannedTripPois',
        style: PoiStyleFunction,
    });

    function getRoutePlanned(coords, func) {
        var url = "//tourist.posazavi.com/Mapy/Proxy/GetRouting.ashx?coords=" + coords;
        console.log("getRoutePlanned loading routing data url", url);
        $.get(url, function (data) {
            BnHelpGml = data.childNodes[0].childNodes[0].attributes["href"].value;
            BnHelpXml = data.childNodes[0].childNodes[1].attributes["href"].value;
            console.log("Found GML: " + BnHelpGml);
            console.log("Found XML: " + BnHelpXml);
            func();


            PlannedTripPoisUrl = getPlannedTripPoisSourceUrl();
            console.log("PlannedTripPoisUrl set to:", PlannedTripPoisUrl);

            if (typeof getTripFilterSelected === 'function') {
                PlannedTripPois.getSource().setUrl(PlannedTripPoisUrl + "&Filter=" + getTripFilterSelected());
                PlannedTripPois.getSource().refresh();
            }
            else {
                console.warn("neexistuje funkce getTripFilterSelected");
            }


            var ajaxUrl = '//tourist.posazavi.com/Mapy/Data/Iterinary.ashx?xml=' + BnHelpXml + '&RoutingType=' + getRoutingId() + '&LanguageId=1';
            console.log("getRoute loading Iterinary", ajaxUrl);
            $.get(ajaxUrl, function (result) {
                $("#iterinar").html(result);
                $("#mapIterinary tbody tr").removeClass("odd");
                $(".iterinaryOuter").show();
                $("#mapIterinary tbody tr:visible:odd").addClass("odd");
            });
        });

    }

    if (typeof getRoutePlanned === 'function') {
        console.log("getRoutePlanned existuje, lze hledat");

        document.getElementById('map').addEventListener('setStart', function (e) {
            startChoosen = true;
            if (startChoosen && endChoosen) getRouteData();
        });
        document.getElementById('map').addEventListener('unsetStart', function (e) { startChoosen = false; });

        document.getElementById('map').addEventListener('setMiddle', function (e) {
            middleChoosen = true;
            if (startChoosen && endChoosen) getRouteData();
        });
        document.getElementById('map').addEventListener('unsetMiddle', function (e) { middleChoosen = false; });

        document.getElementById('map').addEventListener('setEnd', function (e) {

            endChoosen = true;
            if (startChoosen && endChoosen) getRouteData();
        });

        document.getElementById('map').addEventListener('unsetEnd', function (e) { endChoosen = false; });



        const PlannedTripLinie = new VectorLayer({
            style: styleTripFunction,
            source: new VectorSource({
                url: '//tourist.posazavi.com/Mapy/GeoJson/TripPlanning.ashx?gml=' + getBnHelpGml(),
                format: new GeoJSON()
            }),
            name: 'PlannedTripLinie'
        });

        PlannedTripLinie.getSource().on('featuresloadstart', function () {
            console.log("PlannedTripLinie features load start");
        });

        PlannedTripLinie.getSource().on('featuresloaderror', function (e) {
            console.error("PlannedTripLinie features load error", e);
        });

        PlannedTripLinie.getSource().on('featuresloadend', function (e) {
            console.log("PlannedTripLinie features load end", e);
            var features = PlannedTripLinie.getSource().getFeatures();
            features.forEach(function (feature) {
                map.getView().fit(feature.getGeometry(), { padding: [30, 20, 30, 20] }/*, { duration: 1000 }*/);
            });
        });


      

        PlannedTripPois.getSource().on('featuresloadstart', function () {
            console.log("PlannedTripPois features load start");
        });

        PlannedTripPois.getSource().on('featuresloaderror', function (e) {
            console.error("PlannedTripPois features load error", e);
        });

        PlannedTripPois.getSource().on('featuresloadend', function (e) {
            console.log("PlannedTripPois features load end", e);
        });



        // layers.push(PlannedTripLinie);
        //  layers.push(RecomendedTripPois);



        /* pois category selection change */
        if (typeof tripFilterEventListener === 'function') {
            console.log("mam funkci tripFilterEventListener, zapojim filtrovani");
            tripFilterEventListener(filterPlannedClick);
        }
        else {
            console.warn("neexistuje funkce tripFilterEventListener, nepujde filtrovat");
        }



        function getPlannedTripLinieSourceUrl() {
            return '//tourist.posazavi.com/Mapy/GeoJson/TripPlanning.ashx?gml=' + getBnHelpGml();
        }


        function filterPlannedClick() {
            console.log("filterPlannedClick - CLICKED filter for pois category", PlannedTripPoisUrl);
            if (typeof getTripFilterSelected === 'function') {
                PlannedTripPois.getSource().setUrl(PlannedTripPoisUrl + "&Filter=" + getTripFilterSelected());
                PlannedTripPois.getSource().refresh();
            }
            else {
                console.error("neexistuje funkce getTripFilterSelected");
            }

        }


        function changeMap() {
            console.log("changeMap", getBnHelpGml());
            if (!mapInitialized) {
                //tileLayer.setSource(sourceForTileLayer);
                var c = map.getControls();
                //console.log("changeMap", c);
                c.extend([new ScaleLine()]).extend([overviewMapControl]);

                var urlPois = getPlannedTripPoisSourceUrl() + "&Filter=" + getTripFilterSelected();
                console.log("PlannedTripPois setting url to:" + urlPois);
                PlannedTripPois.getSource().setUrl(urlPois);
                PlannedTripLinie.getSource().setUrl(getTripLinieSourceUrl());

                map.addLayer(PlannedTripLinie);
                map.addLayer(PlannedTripPois);
                mapInitialized = true;
                document.getElementById('map').style.display = "block";
            }
            else {
                PlannedTripPois.getSource().setUrl(getPlannedTripPoisSourceUrl() + "&Filter=" + getTripFilterSelected());
                PlannedTripLinie.getSource().setUrl(getTripLinieSourceUrl());
                PlannedTripPois.getSource().refresh();
                PlannedTripLinie.getSource().refresh();
            }
            return;
        }


        function getRouteData() {
            if (typeof getRoutePlanned === 'function') {
                var coords = getStartX() + "," + getStartY() + "," + getEndX() + "," + getEndY();
                if (middleChoosen) coords = getStartX() + "," + getStartY() + "," + getMiddleX() + "," + getMiddleY() + "," + getEndX() + "," + getEndY();


                getRoutePlanned(coords + "&ct=" + getRoutingId(), changeMap);

            }
            else {
                console.error("neexistuje funkce getRoutePlanned");
            }
        }

        function getTripLinieSourceUrl() {
            return '//tourist.posazavi.com/Mapy/GeoJson/TripPlanning.ashx?gml=' + getBnHelpGml();
        }

    }
    else {
        console.error("neni funkce getRoutePlanned neumim vyhledani vyletu");
    }
}
else {
    console.log("neni funkce showPlannedTripLayer nevykresluji vrstvu linii planovaneho vyletu");
}





if (typeof getNatureLinieId === 'function') {
    idTrasy = getNatureLinieId();
    console.log("getNatureLinieId prebral trasuID:" + idTrasy);
}
else {
    console.log("neni funkce getNatureLinieId nevykresluji linii naucne");
}


if (typeof showPlavebniUradLayer === 'function') {
    console.log("showPlavebniUradLayer existuje, zobrazuji");
    layers.push(plavebniUradLayer);
}
else {
    console.log("neni funkce showPlavebniUradLayer nevykresluji vrstvu");
}

if (idTrasy != null) {
    const linieNaucneSource = new VectorSource({
        format: new GeoJSON(),
        url: function (extent) {
            return (
                'https://tourist.posazavi.com/Mapy/Proxy/GetNaturalLinie.ashx?id=' + idTrasy
            );
        }
    });

    const linieNaucne = new VectorLayer({
        source: linieNaucneSource,
        style: {
            'stroke-width': 3,
            'stroke-color': 'red',
            //'fill-color': 'rgba(100,100,100,0.25)',
        },
    });

    linieNaucneSource.on('featuresloadend', function () {
        console.log("linieNaucneSource features load end");
        var features = linieNaucneSource.getFeatures();
        features.forEach(function (feature) {
            map.getView().fit(feature.getGeometry(), { padding: [30, 10, 30, 10] }/*, { duration: 1000 }*/);

        });
    });

    layers.push(linieNaucne);
}




/* pois category selection change */

function filterClick() {
    console.log("Mapy.filterClick - CLICKED filter for pois category");
    if (typeof getTripFilterSelected === 'function') {
        RecomendedTripPois.getSource().setUrl(TripPoisUrl + "&Filter=" + getTripFilterSelected());
        RecomendedTripPois.getSource().refresh();
    }
    else {
        console.error("Mapy neexistuje funkce getTripFilterSelected");
    }

}


const map = new Map({
    layers: layers,
    controls: defaultControls().extend([new ScaleLine()]).extend([overviewMapControl]),
    target: document.getElementById('map'),
    view: new View({
        projection: JTSKprojection,
        center: mapCenter, //[-745663.222138402, -1072290.33303615],
        extent: JTSKprojection.extend, // [-907841.0560214706, -1230916.868999999, -416691.670278527, -932111.7296999972],
        zoom: mapZoom
    }),
});

console.log("Map " + mapVersion + " initialized", mapCenter, mapZoom);
console.log("Map Layers", map.getAllLayers());


/* zoom */

var currZoom = map.getView().getZoom();
map.on('moveend', function (e) {
    var newZoom = map.getView().getZoom();
    if (currZoom != newZoom) {
        console.log('zoom end, new zoom: ' + newZoom);
        currZoom = newZoom;
    }
});

/* popup */

// change mouse cursor when over marker
map.on('pointermove', function (e) {
    const pixel = map.getEventPixel(e.originalEvent);
    const hit = map.hasFeatureAtPixel(pixel);
    map.getTarget().style.cursor = hit ? 'pointer' : '';
});

// display popup on click
map.on('click', function (evt) {
    const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
    });

    if (!feature) {
        return;
    }

    console.log("INFO: before showMapDetail - choosen feature", feature);

    if (typeof showMapDetail === 'function') {
        showMapDetail(feature);
    }
    else {
        console.error("ERR: neexistuje funkce showMapDetail");
    }

});


/* tooltip */

map.on('pointermove', function (evt) {
    if (evt.dragging) {
        mapTooltip.style.visibility = 'hidden';
        currentFeature = undefined;
        return;
    }
    const pixel = map.getEventPixel(evt.originalEvent);
    displayFeatureInfo(pixel, evt.originalEvent.target);
});


const mapTooltip = document.getElementById('mapTooltip');

let currentFeature;
const displayFeatureInfo = function (pixel, target) {
    const feature = target.closest('.ol-control')
        ? undefined
        : map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature;
        });
    if (feature) {
        mapTooltip.style.left = pixel[0] + 'px';
        mapTooltip.style.top = pixel[1] + 'px';
        if (feature !== currentFeature) {
            mapTooltip.style.visibility = 'visible';
            mapTooltip.innerText = feature.get('name');
        }
    } else {
        mapTooltip.style.visibility = 'hidden';
    }
    currentFeature = feature;
};

/* funkce  */

function showPoints(obj, val) {
    var id = $(obj).attr("data-id");
    console.log("showPoints: " + id + "," + val);
    var prefix = $(obj).attr("data-prefix");

    switch (prefix) {
        case "j": displayPointLayer("jezy"); break;
        case "i": displayPointLayer("ic"); break;
        case "n": displayPointLayer("naucne"); break;
        default:
            displayPointLayer(prefix + id);
    }
}
function changeLayerVisibility(l) {
    console.log("changeLayerVisibility", l.layer);

    $(pointLayers).each(function (i, key) {
        if (key.layer == l.layer) {
            key.visible = !key.visible;
            console.log("changeLayerVisibility done", key);
            var tt = map.getAllLayers();
            //var layer = tt["ic"];
            var layer = map.getLayers().getArray().find(layer => layer.get('name') == l.layer);
            layer.setVisible(key.visible);
        }
    });
}

function addLayer(l) {
    console.log("addLayer", l.layer, pointLayers);
    pointLayers.push(l);
    console.log("addLayer done", l.layer, pointLayers);
    console.log(map);

    var mainUrl = "https://tourist.posazavi.com";
    var url = "";
    if (l.layer == "ic") url += "/Mapy/GeoJson/Memories.ashx?Id=153";
    if (l.layer == "jezy") url += "/Mapy/GeoJson/Weirs.ashx";
    if (l.layer == "naucne") url += "/Mapy/GeoJson/NaturalTrails.ashx";

    if (l.layer.substring(0, 1) == "m") url += "/Mapy/GeoJson/Memories.ashx?Id=" + l.layer.substring(1);
    if (l.layer.substring(0, 1) == "s") url += "/Mapy/GeoJson/Services.ashx?Id=" + l.layer.substring(1);
    if (l.layer.substring(0, 1) == "p") url += "/Mapy/GeoJson/Products.ashx?Id=" + l.layer.substring(1);
    if (l.layer.substring(0, 1) == "r") url += "/Mapy/GeoJson/RegionalShops.ashx?Id=" + l.layer.substring(1);
    if (url == "") {
        console.error("not found url for " + l.name + " in addLayer");
    }
    const TripPois = PoisFunction(mainUrl + url, l.layer);

    TripPois.getSource().on('featuresloadstart', function () {
        console.log("PoisLayer features load start");
    });

    TripPois.getSource().on('featuresloaderror', function (e) {
        console.error("PoisLayer features load error", e, l);
    });

    TripPois.getSource().on('featuresloadend', function () {
        console.log("PoisLayer features load end");
    });

    map.addLayer(TripPois);
    TripPois.setVisible(true);
    //console.log(map.getProjection());

}

function displayPointLayer(layer) {

    console.log("displayPointLayer", layer);
    const l = { layer: layer, visible: true };

    if (poisLayersContain(l)) {
        changeLayerVisibility(l);
    }
    else {
        l.visible = false;
        if (poisLayersContain(l)) {
            changeLayerVisibility(l);
        }
        else {
            l.visible = true;

            addLayer(l);
        }
    }

}

var mapInitialized = false;


function poisLayersContain(l) {
    console.log("poisLayersContain", l);
    var found = false;
    $(pointLayers).each(function (i, key) {
        if (key.layer == l.layer) found = true;
    });
    return found;
}

$(".layerSelection input[type='checkbox']").change(function () { showPoints($(this), true); });


document.getElementById("showMapTopo").addEventListener('click', function () {
    ortoLayer.setVisible(false);
    osmLayer.setVisible(false);
    topoLayer.setVisible(true);
    console.log("switching map to topo");
});


document.getElementById("showMapOrto").addEventListener('click', function () {
    ortoLayer.setVisible(true);
    topoLayer.setVisible(false);
    osmLayer.setVisible(false);
    console.log("switching map to orto");
});

document.getElementById("showMapOsm").addEventListener('click', function () {
    ortoLayer.setVisible(false);
    topoLayer.setVisible(false);
    osmLayer.setVisible(true);
    console.log("switching map to osm");
});



if (typeof getLayersToShow === 'function') {
    var l = getLayersToShow();
    if (l != "") {
        var la = l.split(',');
        console.log("getLayersToShow", la);
        $(la).each(function (i, key) {
            var p = key.substring(0, 1);
            var id = key.substring(1);

            if (key == "ic" || key == "m153") {
                id = 2;
                p = "i"
            }
            if (key == "jezy") {
                id = 1;
                p = "j"
            }
            if (key == "naucne" || key == "a35") {
                id = 3;
                p = "n"
            }

            var obj = ".layerSelection input[data-id=" + id + "][data-prefix=" + p + "]";
            var f = $(obj);
            //console.log(obj, f);
            $(f).click();
        });
    }
    else {
        console.log("getLayersToShow - nothing preselected");
    }
}
else {
    console.log("neexistuje funkce getLayersToShow, nebude zadna kategorie zobrazena");
}

